import { render, staticRenderFns } from "./ScrollToButton.vue?vue&type=template&id=477306c2"
import script from "./ScrollToButton.vue?vue&type=script&lang=js"
export * from "./ScrollToButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports